import { Box, Button, useTheme } from "@mui/material";
import { ChevronRight } from "lucide-react";
import type { FC, ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { DashboardSection } from "web_myplann/Dashboard/Components/DashboardSection";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

interface DashboardNotificationSectionV2FrameProps {
	title: string;
	showAllHref: string;
	children: ReactNode;
	testId?: string;
}

export const DashboardNotificationSectionV2Frame: FC<
	DashboardNotificationSectionV2FrameProps
> = ({ title, showAllHref, children, testId }) => {
	const { t } = useResource();
	const theme = useTheme();
	const navigate = useNavigate();

	return (
		<Box data-testid={testId} display="contents">
			<DashboardSection title={title}>
				{children}
				<Button
					variant="showAll"
					onClick={() => navigate(showAllHref)}
					endIcon={<ChevronRight size={theme.iconSize.sm} />}
					data-testid={testId ? `${testId}-show-all` : undefined}
				>
					{t(Resources.Dashboard.ShowAllButton.title)}
				</Button>
			</DashboardSection>
		</Box>
	);
};
